import React, { Component } from 'react'
import moment from 'moment'

import { getLatestPosts } from '../../api/butterCMS';

import { Link } from 'react-router-dom';
import { Signpost } from '../'
import { LazyImage, LoadingSpinner } from '../Global';
import { calculateReadTime } from '../Blog/functions'

export default class LatestPost extends Component {

    state = {
        post: false
    }

    componentDidMount() {
        this.getPost()
    }

    getPost() {
        getLatestPosts({ page: 1, page_size: 1 }).then(({data}) => {
            this.setState({
                post: data[0]
            })
        })
    }

    render() {
        const { post } = this.state

        if (!post) {
            return <LoadingSpinner />
        }
        
        return (
            <Signpost className="c-signpost c-signpost--medium c-signpost--single c-signpost--post u-no-bg u-text-left" isActive={true}>
                <div className="c-signpost__columns">
                    <div className="c-signpost__column c-signpost__column--flexed u-margin--bottom">
                        <div className="u-padding">
                            <h2 className="epsilon u-no-bm"><Link className="u-unstyled" to={'/blog'}>Blog</Link></h2>
                            <p className="c-signpost__text">
                                <Link className="u-unstyled" to={`/blog/${post.slug}`}>
                                    {post.title}
                                </Link>
                            </p>
                            <p className="u-margin--bottom epsilon">{`${moment(post.published).format('LL')} // ${calculateReadTime(post.body)} read`}</p>
                            <p>{post.summary}</p>

                            <Link className="c-signpost__link u-more-link u-unstyled" to={`/blog/${post.slug}`}>Read post</Link>
                        </div>
                    </div>
                    {post.featured_image ?
                        <div className="c-signpost__column c-signpost__image">
                            <Link to={`/blog/${post.slug}`}>
                                <LazyImage src={post.featured_image} alt={post.featured_image_alt} width="709" height="475" />
                            </Link>
                        </div>
                    : ''}
                </div>
            </Signpost>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Blog/LatestPost.js